"use strict";
/* eslint-disable camelcase */
/** Bank Institution */
Object.defineProperty(exports, "__esModule", { value: true });
exports.InterestRateBenchmark = exports.CapitalProviderAccountType = exports.BorrowerAccountType = exports.Currency = void 0;
// use CurrencyCode (below) instead
var Currency;
(function (Currency) {
    Currency["USD"] = "USD";
    Currency["CAD"] = "CAD";
    Currency["MXN"] = "MXN";
    Currency["EUR"] = "EUR";
    Currency["GBP"] = "GBP";
})(Currency = exports.Currency || (exports.Currency = {}));
var BorrowerAccountType;
(function (BorrowerAccountType) {
    BorrowerAccountType["Collections"] = "collections";
    BorrowerAccountType["OtherReserveAccount"] = "otherReserveAccount";
    BorrowerAccountType["ParentOperatingAccount"] = "parentOperatingAccount";
    BorrowerAccountType["PreFundingAccount"] = "preFundingAccount";
    BorrowerAccountType["PermittedInvestmentsAccount"] = "permittedInvestmentsAccount";
    // TODO(jon): we should deprecate fixed account types. Bank accounts don't need to have a specific
    //  type; we just need to be able to customize their properties/behaviors.
    BorrowerAccountType["AccountIncludedInBorrowingBase"] = "accountIncludedInBorrowingBase";
})(BorrowerAccountType = exports.BorrowerAccountType || (exports.BorrowerAccountType = {}));
var CapitalProviderAccountType;
(function (CapitalProviderAccountType) {
    CapitalProviderAccountType["CapitalProviderFundingAccount"] = "capitalProviderFundingAccount";
})(CapitalProviderAccountType = exports.CapitalProviderAccountType || (exports.CapitalProviderAccountType = {}));
var InterestRateBenchmark;
(function (InterestRateBenchmark) {
    InterestRateBenchmark["SOFR"] = "SOFR";
    InterestRateBenchmark["SOFR30DAvg"] = "SOFR30DAvg";
    InterestRateBenchmark["SOFR90DAvg"] = "SOFR90DAvg";
    InterestRateBenchmark["SOFRTerm1M"] = "SOFRTerm1M";
    InterestRateBenchmark["SOFRTerm3M"] = "SOFRTerm3M";
    InterestRateBenchmark["LIBOR1M"] = "LIBOR1M";
    InterestRateBenchmark["LIBOR3M"] = "LIBOR3M";
    InterestRateBenchmark["EURIBOR1M"] = "EURIBOR1M";
    InterestRateBenchmark["EURIBOR3M"] = "EURIBOR3M";
    InterestRateBenchmark["CDOR1M"] = "CDOR1M";
    InterestRateBenchmark["CDOR3M"] = "CDOR3M";
    InterestRateBenchmark["PRIME"] = "PRIME";
    InterestRateBenchmark["TIIE30DAvg"] = "TIIE30DAvg";
    InterestRateBenchmark["CMT5Y"] = "CMT5Y";
})(InterestRateBenchmark = exports.InterestRateBenchmark || (exports.InterestRateBenchmark = {}));
//# sourceMappingURL=Bank.js.map